export class DirtyRect {
  dirty = false;

  minX = 0;
  minY = 0;
  maxX = 0;
  maxY = 0;

  onWrite: () => void;
  widthForIndexes?: number;
  constructor(opts?: { widthForIndexes?: number; onWrite?: () => void }) {
    this.widthForIndexes = opts?.widthForIndexes;
    this.onWrite = opts?.onWrite ?? (() => {});
  }

  reset() {
    this.dirty = false;
    this.onWrite();
  }

  addPointByIndex(index: number, width = this.widthForIndexes) {
    if (width == null) {
      throw new Error("widthForIndexes must be provided");
    }
    const x = index % width;
    const y = Math.floor(index / width);
    this.addPoint(x, y);
  }

  addPoint(x: number, y: number) {
    if (!this.dirty) {
      this.dirty = true;
      this.minX = x;
      this.minY = y;
      this.maxX = x;
      this.maxY = y;
    } else {
      this.minX = Math.min(this.minX, x);
      this.minY = Math.min(this.minY, y);
      this.maxX = Math.max(this.maxX, x);
      this.maxY = Math.max(this.maxY, y);
    }
    this.onWrite();
  }

  get width() {
    return this.maxX - this.minX;
  }
  get height() {
    return this.maxY - this.minY;
  }
}
